/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type SelfieStatusResponseDTO = {
    message?: SelfieStatusResponseDTO.message;
    status?: SelfieStatusResponseDTO.status;
};

export namespace SelfieStatusResponseDTO {

    export enum message {
        VERIFIED_SUCCESSFULLY = 'VERIFIED_SUCCESSFULLY',
        PENDING_VERIFICATION = 'PENDING_VERIFICATION',
        NO_FACE_FOUND = 'NO_FACE_FOUND',
        LOW_IMAGE_QUALITY = 'LOW_IMAGE_QUALITY',
        GENERAL_ERROR_IN_VERIFICATION = 'GENERAL_ERROR_IN_VERIFICATION',
        UNKNOWN = 'UNKNOWN',
    }

    export enum status {
        PENDING_VERIFICATION = 'PENDING_VERIFICATION',
        VERIFIED_SUCCESSFULLY = 'VERIFIED_SUCCESSFULLY',
        NEEDS_MANUAL_VERIFICATION = 'NEEDS_MANUAL_VERIFICATION',
        ERROR_IN_VERIFICATION = 'ERROR_IN_VERIFICATION',
    }


}
